export function prefixHTTP(str) {
  // Regular expression to match URLs without the HTTP/HTTPS prefix
  const url_regex = /^(?!https?:\/\/).+$/;

  // Replace each URL without the prefix with the HTTP/HTTPS prefix
  return str ? str.trim().replace(url_regex, (url) => `https://${url}`) : "";
}

export function replacePlaceholders(str, data) {

  // Regular expression to match placeholders like {{additionalAttributes.foo}}
  const additionalAttributes_regex = /\{\{([\w.]+)\}\}/g;

  str = decodeBase64(str);

  if (!str) return ""

  // Replace each placeholder with its corresponding value from the data
  return str.replace(additionalAttributes_regex, (_, key) => {
    // Split the key by dots to access nested properties
    const keys = key.split(".");
    let value = data;

    // Traverse the nested properties to get the value
    for (const k of keys) {
      if (value.hasOwnProperty(k)) {
        value = value[k];
      } else {
        // Return an empty string if any key is not found
        return "";
      }
    }

    // Return the value to replace the placeholder
    return value;
  });
}

export function decodeBase64(str) {
  // Regular expression to match handlebar decodeBase64 like {{decodeBase64 'Lorem Ipsum' optional}}
  const decodeBase64_regex = /\{\{\s*decodeBase64\s*(['"])\s*([^'"]*?)\s*\1(?:\s+([^\s]+))?\s*\}\}/;
  //const base64_regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  const base64_error = "The string is not a valid Base64 string";

  // Perform the decodeBase64 regex match
  if (!str) return "";
  const match = str.match(decodeBase64_regex);
  if (match) {
    try {
      // The 1st match is the decodeBase64 handlebar name
      // This 2nd match is the encoded base64 string
      // There is a 3rd parameter is optional and not required for microsite
      let base64_str = match[2];

      // Check if str is a valid base64 string
      // str = base64_regex.test(base64_str) ? base64ToUtf8(base64_str) : base64_error;

      // Remove above inaccurate base64_regex.test. Rely on the try-catch block to handle errors
      str = base64ToUtf8(base64_str);

    } catch (error) {

      // Log the error and return the generic base64 error string
      console.log(error)
      str = base64_error;
    }
  }

  // Either return the base64 error or the decoded string
  return str;
}

function base64ToUtf8(base64) {
  const binaryString = atob(base64); // Decode the base64 to a binary string
  const utf8Bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0)); // Convert binary string to bytes
  const utf8String = new TextDecoder().decode(utf8Bytes); // Decode bytes to a UTF-8 string
  return utf8String;
}
